export const TEMPLATES = {
  companyAnalysis: `I need to understand {{Company_Name}} better. Can you provide me with:
    
- A concise categorization: What industry tags best describe this company? If it's hard to categorize, just let me know.
- A brief summary: Describe this company in a nutshell.
- A simple use case: Give me an easy-to-understand example of how someone would use this company's product or service.
    `,
  promptImprovement: `I'm trying to improve how I write prompts for AI chatbots, especially Gemini. Could you help me rephrase the following prompts to be clearer, more direct, and sound more natural? I want to make sure the AI understands exactly what I'm asking.
  
Prompts:
{{My_Prompt}}`,
  // ... other templates
};
